module.exports = __webpack_public_path__ + "static/img/jump.7ae49b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump.png
// module id = WVTH
// module chunks = 1